export const selectWallets = {
	list: (state) => state.wallet.wallets.list,
	fetch: (state) => state.wallet.wallets.fetch,
	addFetch: (state) => state.wallet.wallets.addFetch,
	succes: (state) => state.wallet.wallets.succes,
};
